










import FormContainer from '@/components/FormContainer.vue';

export default {
    name: `FormSection`,
    props: {
        components: {
            type: Object,
            default()
            {
                return {
                    FormContainer
                };
            }
        },
        sectionIs: {
            default: true,
            type: Boolean
        }
    }
};
